<div class="w-screen h-screen flex flex-col gap-8 items-center justify-center">
  <div i18n class="text-6xl font-bold">Oh no...</div>
  <div class="text-4xl font-bold">
    {{ 'NOT_FOUND' | transloco }}
  </div>
  <a i18n class="underline" routerLink="/">Go Back Home</a>
</div>
